<template>
  <v-app style="background-color: #f8f9fb">
    <v-container
      style="background-color: #eee"
      id="financeiro"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-link-variant"
            title="Comunicação Externa"
            color="rgb(71 130 180)"
            style="margin-top: 60px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row style="margin-top: 1rem">
                <!-- Empresa -->
                <v-col cols="12" sm="6" md="2" class="py-0">
                  <span>Modelo</span>
                  <v-select
                    v-model="regra.modelo"
                    :items="['Cobrança', 'Lembrete']"
                    label="Modelo"
                    dense
                    required
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                    solo-inverted
                  ></v-select>
                </v-col>
                <!-- Empresa -->
                <v-col cols="12" sm="6" md="2" class="py-0">
                  <span>Empresa</span>
                  <v-select
                    v-model="regra.empresa"
                    :items="filteredEmpresas"
                    label="Empresa"
                    dense
                    required
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                    solo-inverted
                  ></v-select>
                </v-col>

                <!-- Tipo Contrato -->
                <v-col cols="12" sm="6" md="2" class="py-0">
                  <span>Tipo do Contrato</span>
                  <v-select
                    dense
                    solo-inverted
                    required
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                    :items="['Planos', 'Cemitérios']"
                    v-model="regra.tipo_contrato"
                    label="Tipo Contrato"
                  ></v-select>
                </v-col>

                <!-- Tipo da Parcela -->
                <v-col cols="12" sm="6" md="2" class="py-0">
                  <span>Tipo da Parcela</span>
                  <v-select
                    dense
                    solo-inverted
                    required
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                    :items="['Contrato', 'Venda']"
                    v-model="regra.tipo_parcela"
                    label="Tipo da Parcela"
                  ></v-select>
                </v-col>

                <!-- Dias de Antecedência -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span
                    >Dias de
                    {{
                      regra.modelo === "Cobrança" ? "Atraso" : "Antecedência"
                    }}</span
                  >
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="regra.dias_condicoes"
                    :label="
                      'Dias de ' +
                      (regra.modelo === 'Cobrança' ? 'Atraso' : 'Antecedência')
                    "
                    type="number"
                    :max="10000"
                    :min="1"
                    :rules="[(v) => !!v || 'Este campo é obrigatório']"
                  ></v-text-field>
                </v-col>

                <!-- Horário -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Horário</span>
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="regra.horario"
                    label="Horário"
                    type="time"
                    :rules="[(v) => !!v || 'Este campo é obrigatório']"
                  ></v-text-field>
                </v-col>

                <!-- Data Inicial -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Data Inicial</span>
                  <v-menu
                    v-model="isStartDatePickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    bottom
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="regra.data_inicial"
                        label="Data Inicial"
                        dense
                        solo-inverted
                        readonly
                        required
                        :rules="[
                          (v) =>
                            (v != null && v !== '') ||
                            'Este campo é obrigatório',
                        ]"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      no-title
                      v-model="localSelectedStartDateISO"
                      @input="handleStartDateSelection"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- Data Final -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Data Final</span>
                  <v-menu
                    v-model="isEndDatePickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    bottom
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="regra.data_final"
                        label="Data Final"
                        dense
                        solo-inverted
                        readonly
                        v-on="on"
                        :disabled="regra.indeterminate"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      no-title
                      v-model="localSelectedEndDateISO"
                      :disabled="regra.indeterminate"
                      @input="handleEndDateSelection"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- Ativar a Data Final -->
                <v-switch
                  color="blue"
                  v-model="regra.indeterminate"
                  label="Final Indeterminado"
                  class="mt-6"
                ></v-switch>

                <!-- Mensagem para Disparo -->
                <v-col cols="8" class="py-0">
                  <v-textarea
                    dense
                    solo-inverted
                    label="Mensagem para Disparo"
                    filled
                    auto-grow
                    rows="1"
                    row-height="20"
                    :rules="[
                      (v) =>
                        mensagemRealLength <= 160 || 'Mensagem muito longa',
                    ]"
                    v-model="regra.mensagem"
                  />

                  <div class="d-flex justify-end">
                    <small class="text-caption">
                      {{ mensagemRealLength }}/160
                    </small>
                  </div>

                  <v-text
                    class="text-primary text-decoration-underline"
                    @click="dialog = true"
                    style="cursor: pointer"
                  >
                    Variáveis disponíveis
                  </v-text>
                </v-col>
                <v-col cols="4" class="py-0">
                  <!-- Ativar a Data Final -->
                  <v-switch
                    color="blue"
                    v-model="regra.status"
                    label="Status da Regra"
                    class="mt-0"
                  ></v-switch>
                </v-col>
              </v-row>

              <v-card-actions class="d-flex justify-end">
                <v-btn
                  small
                  v-if="!showEditar"
                  :loading="loadingCreate"
                  color="primary"
                  @click="adiciona_regra()"
                  class="pr-4"
                >
                  <v-icon left>mdi-plus</v-icon>Nova Regra
                </v-btn>
                <v-btn
                  outlined
                  small
                  v-if="showEditar"
                  color="red"
                  @click="clear_atualizacao()"
                >
                  <v-icon left>mdi-cancel</v-icon>Cancelar Edição
                </v-btn>
                <v-btn
                  small
                  v-if="showEditar"
                  :loading="loadingUpdate"
                  color="warning"
                  @click="atualizar_regra()"
                  class="mr-0"
                >
                  <v-icon left>mdi-update</v-icon>Atualizar Regra
                </v-btn>
              </v-card-actions>
            </v-form>

            <v-data-table
              style="margin-top: 1rem"
              :headers="ranking_header"
              :items="listaRegras"
              :items-per-page="50"
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <br />
              <br />
              <br />
              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoading"
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>
              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td class="linha">
                    <v-chip
                      :color="getStatusCor(row.item.mensageria_cliente.empresa)"
                      text-color="white"
                    >
                      {{ row.item.mensageria_cliente.empresa }}
                    </v-chip>
                  </td>
                  <td class="linha">
                    {{ row.item.mensageria.mensagem }}
                  </td>
                  <td class="linha">
                    {{ row.item.mensageria_cliente.tipo_parcela }}
                  </td>

                  <td class="linha">
                    {{ row.item.mensageria_cliente.tipo_contrato }}
                  </td>
                  <td class="linha">
                    {{ row.item.mensageria_cliente.modelo }}
                  </td>
                  <td class="linha">
                    {{ row.item.mensageria_cliente.dias_condicoes }}
                  </td>

                  <td class="linha">
                    {{ row.item.mensageria.horario }}
                  </td>
                  <td class="linha">
                    <v-chip
                      :color="getStatusDisparoCor(row.item.mensageria.status)"
                      text-color="white"
                    >
                      {{ getStatus(row.item.mensageria.status) }}
                    </v-chip>
                  </td>
                  <td class="linha">
                    <v-btn
                      @click="editarRegra(row.item)"
                      text
                      small
                      color="warning"
                    >
                      <v-icon dark> mdi-pencil </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" max-width="800px">
        <v-card>
          <v-card-title class="headline">Variáveis Disponíveis</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="variaveis"
              dense
              hide-default-footer
            >
              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <!-- Nome da variável + Botão Copiar -->
                  <td class="linha" style="width: 20%">
                    <div class="d-flex align-center">
                      <code>{{ row.item.nome }}</code>
                      <v-spacer></v-spacer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="copiarTexto(row.item.nome)"
                          >
                            <v-icon size="17" center>mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                        <span>Copiar</span>
                      </v-tooltip>
                    </div>
                  </td>

                  <!-- Descrição -->
                  <td class="linha" style="width: 20%">
                    <v-chip small color="blue lighten-4">{{
                      row.item.descricao
                    }}</v-chip>
                  </td>

                  <!-- Exemplo -->
                  <td class="linha" style="width: 30%">
                    <p
                      class="text-body-2 text-grey-darken-1"
                      style="max-width: 100%"
                    >
                      {{ row.item.exemplo }}
                    </p>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined small @click="dialog = false">
              <v-icon left>mdi-close</v-icon>Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>
<script>
import { ContentLoader } from "vue-content-loader";
import VuetifyMoney from "./components/VuetifyMoney.vue";
import mensageria from "../../services/mensageria";

export default {
  name: "MensageriaLembrete",
  components: {
    apexcharts: ContentLoader,
    "vuetify-money": VuetifyMoney,
  },

  created() {},

  mounted() {
    this.consultar_regras();
  },

  computed: {
    filteredEmpresas() {
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
    mensagemRealLength() {
      let mensagem = this.regra.mensagem || "";
      let length = mensagem.length;

      this.variaveis.forEach((v) => {
        const regex = new RegExp(v.nome, "g");
        const ocorrencias = (mensagem.match(regex) || []).length;

        // Subtrai o tamanho da variável e soma o tamanho do valor real (tamanho definido)
        length += ocorrencias * (v.tamanho - v.nome.length);
      });

      return length;
    },
  },

  data() {
    return {
      variaveis: [
        {
          nome: "{{contrato}}",
          descricao: "Contrato do Cliente",
          exemplo: "MP012234",
          tamanho: 9,
        },
        {
          nome: "{{identificacao}}",
          descricao: "Identificação Fatura",
          exemplo: "03/25",
          tamanho: 5,
        },
        {
          nome: "{{vencimento}}",
          descricao: "Data de Vencimento",
          exemplo: "25/03/2025",
          tamanho: 10,
        },
        {
          nome: "{{codigobarras}}",
          descricao: "Código de Barras",
          exemplo: "23793.04708  90001.196063  11022.795709  8  99220000000500",
          tamanho: 58,
        },
      ],
      headers: [
        { text: "Variável", value: "nome" },
        { text: "Descrição", value: "descricao" },
        { text: "Exemplo", value: "exemplo" },
      ],
      loadingCreate: false,
      loadingUpdate: false,
      valid: false,
      dialog: false,
      showEditar: false,
      listaRegras: [],
      regra: {
        id: 0,
        empresa: "",
        tipo_contrato: "",
        tipo_parcela: "",
        horario: "",
        dias_condicoes: "",
        data_inicial: "",
        data_final: "",
        indeterminate: true,
        mensagem: "",
        status: true,
        modelo: "Lembrete",
      },
      isStartDatePickerOpen: false,
      isEndDatePickerOpen: false,
      localSelectedStartDateISO: "",
      localSelectedEndDateISO: "",
      ranking_header: [
        { text: "Empresa", value: "empresa" },
        { text: "Mensagem Disparo", value: "mensagem" },
        { text: "Tipo Parcela", value: "tipo_parcela" },
        { text: "Tipo Contrato", value: "tipo_contrato" },
        { text: "Modelo", value: "modelo" },
        { text: "Dias Antecedência", value: "dias_condicoes" },
        { text: "Horário disparo", value: "horario" },
        { text: "Status", value: "status" },
        { text: "Ações", value: "acao" },
      ],
      isLoading: false,
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        // "PARQUE DAS FLORES"
      ],
    };
  },

  methods: {
    copiarTexto(texto) {
      navigator.clipboard
        .writeText(texto)
        .then(() => {})
        .catch((err) => {
          console.error("Erro ao copiar:", err);
        });
    },
    getStatusCor(status) {
      switch (status) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "CEMITERIO PREVIDA SÃO MIGUEL":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";
        case "A FLOR DO CAFÉ":
          return "purple lighten-1";
        default:
          "success";
      }
    },
    getStatusDisparoCor(status) {
      switch (status) {
        case true:
          return "green darken-1";
        case false:
          return "red";
      }
    },
    getStatus(status) {
      switch (status) {
        case true:
          return "ATIVO";
        case false:
          return "DESATIVADO";
      }
    },
    editarRegra(item) {
      const indeterminateTemp =
        item.mensageria.data_final === null ? true : false;
      this.regra = {
        id: item.mensageria.id,
        empresa: item.mensageria_cliente.empresa || "",
        tipo_contrato: item.mensageria_cliente.tipo_contrato || "",
        tipo_parcela: item.mensageria_cliente.tipo_parcela || "",
        horario: item.mensageria.horario || "",
        dias_condicoes: item.mensageria_cliente.dias_condicoes || "",
        data_inicial: item.mensageria.data_inicial || "",
        data_final: item.mensageria.data_final || "",
        indeterminate: indeterminateTemp,
        mensagem: item.mensageria.mensagem || "",
        status: item.mensageria.status,
        modelo: item.mensageria.model || "Lembrete",
        mensageriaIdCliente: item.mensageria_cliente.id,
      };
      // Exibir modal de edição
      this.showEditar = true;
    },
    clear_atualizacao() {
      this.consultar_regras();
      this.showEditar = false;

      this.$refs.form.reset();

      this.$nextTick(() => {
        this.regra.indeterminate = true;
        this.regra.status = true;
        this.regra.id = 0;
      });
    },
    handleStartDateSelection() {
      this.regra.data_inicial = this.convertDate(
        this.localSelectedStartDateISO
      );
      this.isStartDatePickerOpen = false;
    },

    handleEndDateSelection() {
      this.regra.data_final = this.convertDate(this.localSelectedEndDateISO);
      this.isEndDatePickerOpen = false;
    },
    convertDate(dateString, format = "iso") {
      if (!dateString) return "";

      if (format === "iso") {
        // Verifica se a string está no formato ISO completo (contém 'T')
        if (dateString.includes("T")) {
          dateString = dateString.split("T")[0]; // Remove a parte do horário
        }

        // Converte de ISO (YYYY-MM-DD) para BR (DD/MM/YYYY)
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
      } else if (format === "br") {
        // Converte de BR (DD/MM/YYYY) para ISO (YYYY-MM-DD)
        const [day, month, year] = dateString.split("/");
        return `${year}-${month}-${day}`;
      }

      return dateString; // Retorna a string original se o formato não for reconhecido
    },
    hasPermission(empresa) {
      this.user = JSON.parse(sessionStorage.getItem("user"));

      if (this.user.roles.includes("ROLE_ADMIN")) {
        return true;
      } else if (empresa === "Todas") {
        return true;
      } else {
        const requiredRoles = empresa
          .split(",")
          .map(
            (name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_")
          );

        const hasAnyRequiredRole = requiredRoles.some((role) =>
          this.user.roles.includes(role)
        );
        return hasAnyRequiredRole;
      }
    },

    adiciona_regra() {
      if (this.regra.mensagem.length > 160) {
        return;
      }
      this.loadingCreate = true;
      // Função para converter DD/MM/YYYY para ISO 8601 completo
      const formatDateToISO = (dateStr) => {
        if (!dateStr) return ""; // Evita erro se a data estiver vazia
        const [day, month, year] = dateStr.split("/");
        const date = new Date(`${year}-${month}-${day}T00:00:00.000Z`); // Garante o formato correto
        return date.toISOString(); // Converte para formato ISO completo
      };

      const dadosFormatados = {
        mensageria: {
          horario: this.regra.horario,
          data_inicial: this.regra.data_inicial,
          data_final: this.regra.indeterminate
            ? this.regra.data_final
            : this.regra.data_inicial,
          mensagem: this.regra.mensagem,
          status: this.regra.status,
          tipo: "cliente",
        },
        mensageria_cliente: {
          tipo_contrato: this.regra.tipo_contrato,
          tipo_parcela: this.regra.tipo_parcela,
          empresa: this.regra.empresa,
          dias_condicoes: this.regra.dias_condicoes,
          modelo: this.regra.modelo,
        },
      };

      if (this.$refs.form.validate()) {
        mensageria
          .salvar_regrav2(dadosFormatados)
          .then((response) => {})
          .catch((e) => {})
          .finally(() => {
            this.consultar_regras();
            this.clear_atualizacao();
            this.valid = false;
            this.loadingCreate = false;
          });
      }
      this.loadingCreate = false;
    },
    consultar_regras() {
      mensageria
        .lista_regrasv2("cliente")
        .then((response) => {
          this.listaRegras = response.data;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {});
    },
    atualizar_regra() {
      this.loadingUpdate = true;

      // Função para converter DD/MM/YYYY para ISO 8601 completo
      const formatDateToISO = (dateStr) => {
        if (!dateStr) return ""; // Evita erro se a data estiver vazia
        const [day, month, year] = dateStr.split("/");
        const date = new Date(`${year}-${month}-${day}T00:00:00.000Z`); // Garante o formato correto
        return date.toISOString(); // Converte para formato ISO completo
      };

      console.log(this.regra);

      const dadosFormatados = {
        mensageria: {
          id: this.regra.id,
          horario: this.regra.horario,
          data_inicial: this.regra.data_inicial,
          data_final: this.regra.indeterminate
            ? this.regra.data_final
            : this.regra.data_inicial,
          mensagem: this.regra.mensagem,
          status: this.regra.status,
          tipo: "cliente",
        },
        mensageria_cliente: {
          id: this.regra.mensageriaIdCliente,
          tipo_contrato: this.regra.tipo_contrato,
          tipo_parcela: this.regra.tipo_parcela,
          empresa: this.regra.empresa,
          dias_condicoes: this.regra.dias_condicoes,
          modelo: this.regra.modelo,
        },
      };

      if (this.$refs.form.validate()) {
        mensageria
          .salvar_regrav2(dadosFormatados)
          .then((response) => {})
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.consultar_regras();
            this.clear_atualizacao();
            this.valid = false;
            this.loadingUpdate = false;
          });
      }
      this.loadingUpdate = false;
    },
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

.v-menu__content {
  box-shadow: none !important;
  top: 4px !important;
}

.justify-center {
  justify-content: center;
}

.gray-row {
  background-color: rgb(71 130 180);
}

.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important;
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}

.card-container {
  display: flex;
  justify-content: space-around;
}
</style>
